import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import IdentityVerificationMatchResultLayout
  from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent/ReviewDetailsLayout';
import { IdentityVerificationReviewDetailsDialogOverride } from 'Overrides/identityVerificationReviewsOverride';

const styles = () => ({
  root: {},
  form: {
    height: '100%',
  },
});

const ReviewDetailsContent = ({
  className,
  classes,
  resource,
  onDecisionMade,
  onDecisionSubmitted,
  onReopen,
  onBack,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaFormInline
        classes={{
          root: classNames(classes.root, className),
          form: classes.form,
        }}
        resource={resource}
        metaOverrideSet={IdentityVerificationReviewDetailsDialogOverride}
        layout={IdentityVerificationMatchResultLayout}
        LayoutProps={{
          onDecisionMade,
          onReopen,
          onDecisionSubmitted,
          onBack,
          hideErrorList: true,
        }}
        inlineSubmit
        readonly
      />
    </Box>
  );
};

ReviewDetailsContent.defaultProps = {
  className: '',
};

ReviewDetailsContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  onDecisionMade: PropTypes.func.isRequired,
  onReopen: PropTypes.func.isRequired,
  onDecisionSubmitted: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default withStyles(styles)(ReviewDetailsContent);
